var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.showCreateForm
        ? _c("div", { staticClass: "mb-5" }, [
            _c(
              "span",
              { on: { click: _vm.onAddReminder } },
              [
                _c("add-button", {
                  attrs: {
                    buttonText: _vm.$t("addNewMedicationReminder"),
                    showTextOnMobile: ""
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showCreateForm
        ? _c("medication-reminder-form", {
            attrs: {
              formData: _vm.formData,
              medicationCode: _vm.medicationCode
            },
            on: { onShowReminderMenu: _vm.onShowReminderMenu }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.showCreateForm
        ? _c(
            "b-row",
            { staticClass: "row-gap" },
            _vm._l(_vm.reminders, function(item, index) {
              return _c("medication-reminder-block", {
                key: "reminderBlock" + index,
                attrs: {
                  id: item.id,
                  reminderType: item.reminderType,
                  medicationName: item.medication.name,
                  tabletsLeft: item.tabletsReminder.left,
                  notes: item.notes,
                  interval: item.interval,
                  cyclic: item.cyclic,
                  severalTimesWeek: item.severalTimesWeek,
                  severalTimesDay: item.severalTimesDay,
                  tabletsReminderSent: item.tabletsReminder.reminderSent
                },
                on: {
                  onEdit: function($event) {
                    return _vm.loadFormData($event)
                  },
                  onDelete: _vm.onShowReminderMenu,
                  onRefreshMedications: _vm.onShowReminderMenu
                }
              })
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67cd7020", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67cd7020","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/clinicHistory/medicationReminder/MedicationReminderView.vue
// module id = 3852
// module chunks = 5